import ProductCardUnitsPallets from './ProductCardUnitsPallets';

export default ProductCardUnitsPallets;
